import { Component, OnInit, Input } from '@angular/core';
import { BillingFormComponent } from 'ngx-intellforce-billing/lib/components/billing-form/billing-form.component';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss']
})
export class ImpressumComponent implements OnInit {

  @Input() form: BillingFormComponent;
  constructor() { }

  ngOnInit() {
  }

}
